export default "__VITE_ASSET__MGgS05Up__"